module.exports = "https://cdn.hellotech.com/client-assets/remote-chat_6678b85244ed9a12e7707fd854281fd7.svg";